import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { NJButton, NJFormItem, NJText } from '@engie-group/fluid-design-system-react';
import { UMSelect } from '../../urbanmap/_components';
import type { Rule } from './types';
import { useDraftGuard } from './DirtyContext';

export function RuleEditor({ label, rule, local, onSave }: {
  label: string; rule: Rule; local?: boolean; onSave: (rule: Rule) => void;
}) {
  const { control, handleSubmit, watch, setValue, reset, formState: { errors, isDirty } } = useForm<Rule>({
    defaultValues: rule,
  });
  useEffect(() => { if (!isDirty) reset(rule); }, [isDirty, reset, rule]);
  const mode = watch('mode');
  useDraftGuard(isDirty);
  return <form className="sp-rule" onSubmit={handleSubmit(value => {
    const applied = { ...value, weight: value.mode === 'weighted' ? value.weight : rule.weight };
    onSave(applied);
    reset(applied);
  })}>
    <NJText as="div"><strong>{label}</strong></NJText>
    <UMSelect ariaLabel={`Mode ${label}`} value={mode} onChange={v => {
      if (v === 'weighted' || v === 'forbidden' || (local && v === 'forced')) setValue('mode', v, { shouldDirty: true });
    }} options={[
      { value: 'weighted', label: 'Pondéré' }, { value: 'forbidden', label: 'Interdit' },
      ...(local ? [{ value: 'forced', label: 'Forcé · tronçon intégral' }] : []),
    ]} />
    {mode === 'weighted' && <Controller name="weight" control={control} rules={{
        validate: value => mode !== 'weighted' || (Number.isFinite(value) && value > 0) || 'Saisissez un poids strictement positif.',
      }} render={({ field }) => <NJFormItem
        id={`weight-${label}`} label={`Poids ${label}`} type="number" step="any"
        value={Number.isNaN(field.value) ? '' : String(field.value)} onBlur={field.onBlur}
        onChange={e => { if (e.target instanceof HTMLInputElement) field.onChange(e.target.valueAsNumber); }}
        hasError={!!errors.weight} subscriptMessage={errors.weight?.message}
      />} />}
    <NJButton label={`Appliquer · ${label}`} type="submit" scale="sm" emphasis="subtle" disabled={!isDirty} />
  </form>;
}
